import ApiService from "../../../services/api.service";

const TermOfItemService = {
	createDraft(data) {
		return ApiService.post(`/warehouse-document/create`, data)
	},
	getListIn(data) {
		return ApiService.post(`/warehouse-document/search/spisat-in`, data)
	},
	getListOut(data) {
		return ApiService.post(`/warehouse-document/search/spisat-out`, data)
	},
	save(data) {
		return ApiService.post(`/warehouse-document/write-off-new-termOfItem`, data)
	},
	getById(id) {
		return ApiService.get(`/warehouse-document/get-spisat-out/${id}`)
	},
	getByIdIn(id) {
		return ApiService.get(`/warehouse-document/get-spisat-in/${id}`)
	},
	deleteDoc(id) {
		return ApiService.delete(`/warehouse-document/delete-writeTermOffItem/${id}`)
	}
}

export default TermOfItemService
